import { gsap } from 'gsap';
import reveal from '../reveal.js';

export default function (section) {
	// Each case on its own, as it comes into view: the cards are stacked, the last ones below the screen while the first shows.
	for (const client of section.querySelectorAll('.client')) {
		// Read once, with their sign and unit as they are: while counting, the figures show the count instead.
		const counts = [...client.querySelectorAll('.metrics strong')].map((figure) => {
			const [, prefix, number, suffix] = figure.textContent.match(/^(\D*)(\d+)(\D*)$/) ?? [];

			return number && { figure, prefix, number: Number(number), suffix, value: 0 };
		});

		reveal(client, () => {
			// Each figure counts up from zero while it rises (cases.css), from the same --delay.
			counts.forEach((count, i) => {
				if (!count) {
					return;
				}

				const { figure, prefix, number, suffix } = count;

				figure.textContent = `${prefix}0${suffix}`;
				// overwrite: revealed again while still counting, it starts over.
				gsap.fromTo(count, { value: 0 }, {
					value: number,
					duration: 1.6,
					delay: 0.2 + i * 0.12,
					ease: 'power3.out',
					overwrite: true,
					onUpdate: () => {
						figure.textContent = `${prefix}${Math.round(count.value)}${suffix}`;
					},
				});
			});
		});
	}
}
